import React, { useState, useEffect, useRef } from "react";

const DateInput = ({ value, onChange }) => {
  const dateInputRef = useRef(null);

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "";
    if (dateString.includes("-")) return dateString;

    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${year}-${month}-${day}`;
  };

  const [inputValue, setInputValue] = useState(formatDisplayDate(value));

  useEffect(() => {
    setInputValue(formatDisplayDate(value));
  }, [value]);

  const handleNumberInput = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");

    if (numbers.length === 8) {
      const year = numbers.substring(0, 4);
      const month = numbers.substring(4, 6);
      const day = numbers.substring(6, 8);

      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() === parseInt(year) &&
        date.getMonth() === parseInt(month) - 1 &&
        date.getDate() === parseInt(day)
      ) {
        const formattedDate = `${year}-${month}-${day}`;
        setInputValue(formattedDate);
        onChange(formattedDate);
      } else {
        setInputValue(numbers);
      }
    } else {
      setInputValue(numbers);
    }
  };

  const handleDateSelect = (e) => {
    const selectedDate = e.target.value;
    setInputValue(selectedDate);
    onChange(selectedDate);
  };

  const handleCalendarClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  return (
    <div className="date-only-container">
      <div className="date-only-wrapper">
        <input
          type="text"
          value={inputValue}
          onChange={handleNumberInput}
          placeholder="YYYYMMDD"
          maxLength="10"
          className="date-only-input"
        />
        <button
          type="button"
          className="date-only-calendar-button"
          onClick={handleCalendarClick}
        >
          <svg
            className="date-only-calendar-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </button>
        <input
          ref={dateInputRef}
          type="date"
          value={value || ""}
          onChange={handleDateSelect}
          className="date-only-calendar-input"
          style={{
            opacity: 0,
            position: "absolute",
            width: "1px",
            height: "1px",
          }}
        />
      </div>
    </div>
  );
};

export default DateInput;
